import store from "./Store";

export const dispatcher = (type, payload) => {
  store.dispatch({type: type, payload: payload});
};

export const requestPOFromStore = () => {
  return store.getState().purchaseOrders;
};

export const requestPOFromStoreById = (POID) => {
  const poList = store.getState().purchaseOrders
  for (const item of poList) {
    if (item.POID === POID) {
      return item
    }
  }
};


export const requestForecastFromStore = () => {
  return store.getState().forecastOrder;
};

export const requestGRNFromStore = () => {
  return store.getState().goodsReceiveNotes;
};

export const requestInvoiceDataFromStore = () => {
  return store.getState().invoices;
};

export const requestRejectedQCFromStore = () => {
  return store.getState().rejectedQC;
};

export const requestRejectedQCForPOFromStore = () => {
  return store.getState().rejectedQCForPO;
};

export const requestRejectedQCHistoryFromStore = () => {
  return store.getState().rejctedQCHistory;
}

export const getGeneratedInvoicesFromStore = () =>{
  return store.getState().genratedInvoice;
}

export const requestCompletedInvoice = () =>{
  return store.getState().completedInvoices;
}
